import React from 'react';
import styled from 'styled-components';

type ArrowRightProps = Omit<React.SVGProps<SVGSVGElement>, 'ref'> & {
  color?: string;
  scale?: number;
};

const StyledSvg = styled.svg.withConfig({
  shouldForwardProp: (prop) => prop !== 'scale',
})<{ scale?: number }>`
  color: var(--way-colors-svgColor);
  height: ${({ scale = 1 }) => 20 * scale}px;
  width: ${({ scale = 1 }) => 20 * scale}px;
`;

const ArrowRight = ({ color, scale = 1, ...props }: ArrowRightProps) => {
  return (
    <StyledSvg
      fill="none"
      scale={scale}
      style={{ color }}
      viewBox="0 0 14 14"
      {...props}
    >
      <g id="&#240;&#159;&#166;&#134; icon &#34;arrows right&#34;">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2921 7.4H0V6.5H12.2929L7 1.20711L7.70711 0.5L13.8032 6.59607V7.30318L7.70711 13.3992L7 12.6921L12.2921 7.4Z"
          fill="currentColor"
          fillOpacity="0.8"
        />
      </g>
    </StyledSvg>
  );
};

export default ArrowRight;
